import React, { useEffect } from 'react';
import PageHeaderText from 'components/base/page-header-text';
import { ReactComponent as BrandDetailsIcon } from 'assets/icons/brand-details.svg';
import { ReactComponent as MealDetailsIcon } from 'assets/icons/meals.svg';
import { ReactComponent as MetadataIcon } from 'assets/icons/metadata.svg';
import { Outlet, useParams } from 'react-router-dom';
import useDashboardContext from 'contexts/dashboard.context';
import { ROUTE_KEYS } from 'utils/constants';
import RightSidebar from 'components/right-sidebar';
import useMealContext from 'contexts/meal.context';
import PageText from 'components/base/page-text';
import { Breadcrumbs } from '@cokitchen/cokitchen-components';
const EditMealContent = () => {
  const { id } = useParams();
  const { meal, loading } = useMealContext();
  const { setRightSection } = useDashboardContext();
  const MEAL_NAV_LIST = [
    {
      title: 'Brand details',
      link: `edit-meal/${id}/${ROUTE_KEYS.NEW_MEAL_BRAND_DETAILS}`,
      Icon: BrandDetailsIcon
    },
    {
      title: 'Meal details',
      link: `edit-meal/${id}/${ROUTE_KEYS.NEW_MEAL_DETAILS}`,
      Icon: MealDetailsIcon
    },
    {
      title: 'Metadata info',
      link: `edit-meal/${id}/${ROUTE_KEYS.NEW_MEAL_METADATA}`,
      Icon: MetadataIcon
    }
  ];

  useEffect(() => {
    setRightSection(<RightSidebar list={MEAL_NAV_LIST} />);

    return () => {
      setRightSection(null);
    };
  }, []);

  const breadCrumbs = [
    {
      name: meal.brand?.name ? `View ${meal.brand.name}` : '...',
      path: `${ROUTE_KEYS.MEALS}?brand_id=${meal.brand?.id}`
    },
    {
      name: meal.meal_category?.name ?? '...',
      path: `${ROUTE_KEYS.MEALS}/${meal?.meal_category_id}`
    },
    {
      name: meal?.name,
      path: ''
    }
  ];

  return (
    <div>
      <Breadcrumbs breadcrumbs={breadCrumbs} />
      <PageHeaderText title={`Edit ${meal?.name ?? 'meal'}`} description='Update meal details.' />
      {loading ? <PageText text='Loading...' /> : <Outlet />}
    </div>
  );
};

export default EditMealContent;
